export default "__VITE_ASSET__d0ed2b8b__"